import React, { Fragment, useState } from 'react';
import { Grid, Card, Toolbar, CardContent, Dialog, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import DropZone from '../files/dropzone';
import Config from '../../config';
import Auth from '../../auth';
import axios from 'axios';

type LogoManagerProps = {
    // Forwarded straight through to Grid's `size` prop by the caller
    // (e.g. account_info.js passes a per-breakpoint object); kept permissive
    // to match Grid's own ResponsiveStyleValue<GridSize> shape.
    gridItem?: any;
};

const LogoManager = (props: LogoManagerProps) => {
    const [showError, setShowError] = useState(false);
    const [logoError, setLogoError] = useState<string | undefined>(undefined);
    const [, setNoSmallLogo] = useState<boolean | undefined>(undefined);
    const [noLargeLogo, setNoLargeLogo] = useState<boolean | undefined>(undefined);

    const getLogoUrl = (size: string) => {
        var coid = Auth.getAccountNumber();
        return `${Config.logos}${coid}${size}.jpg?time=${new Date().getTime()}`;
    };

    const upload = async (type: string, file: File) => {
        var url = '';
        if(type === 'small'){
            url = Config.api + '/api/v1/Account/SmallLogo';
        }else if(type === 'large'){
            url = Config.api + '/api/v1/Account/LargeLogo';
        }
        else{
            return;
        }
        var formData = new FormData();
        formData.append("file", file);
        try{
            await axios.post(url, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
              }
            });
            setNoSmallLogo(false);
            setNoLargeLogo(false);
        }catch(e){
            setShowError(true);
            setLogoError("Unexpected error uploading logo. Please make sure it is a valid image file.");
        }
    };

    const onDropLarge = (files: File[]) => {
        if(!files || !files.length){
            return;
        }
        upload('large', files[0]);
    };

    return <Fragment>
        <Grid size={props.gridItem} style={{display: 'flex'}}>
            <Card style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                <Toolbar className='lbtoolbar' style={{flex: 0}}>Company Logo</Toolbar>
                <CardContent style={{display: 'flex', flex: 1}}>
                    <Grid container spacing={2} style={{flex: 1}}>
                        <Grid size={12} style={{display: 'flex'}}>
                        {Auth.hasPermission("settings/manage") ?
                        <DropZone accept="image/*" style={{width: '100%', minHeight: '10em', flex: 1}} onDrop={onDropLarge}>
                        {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }: any) => {
                            if (isDragAccept || isDragReject) {
                              return "Drop here to upload this file.";
                            }
                            return <div>
                                    {noLargeLogo ? '' : <img alt='Large company logo' style={{marginBottom: '1em', maxWidth: 'calc(100% - 10px)'}} src={getLogoUrl('large')} onError={() => setNoLargeLogo(true)}/>}
                                    <div>Drop an image file here or click to choose an image.</div>
                                    <div style={{marginTop: '1em'}}>This logo will be displayed on packing slips and on your company profile in the Discover Partners page.</div>
                                    <div>Images more than 480 pixels tall or wide will be resized.</div>
                                </div>;
                          }}
                        </DropZone>
                        : (noLargeLogo ? '' : <img alt='Large company logo' style={{marginBottom: '1em'}} src={getLogoUrl('large')} onError={() => setNoLargeLogo(true)}/>)}

                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
        <Dialog open={showError}>
            <Toolbar className='lbtoolbar'>Error</Toolbar>
            <DialogContent>
            <Typography>{logoError}</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowError(false)} color="primary">
                Close
              </Button>
            </DialogActions>
        </Dialog>
    </Fragment>;
};

export default LogoManager;
